export const environment = {
  production: false,
  apiUrl: 'https://apis.dev.auckland.ac.nz/gpe/calculator/v1/getEducationProviders/search?description=',
  googleTagId: 'GTM-TQ8VRCS',
};
